<template>
<section class="viewContainer">
  <!-- 活动-数据 -->
  <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
    <el-tab-pane label="报名记录" name="ninth"/>
    <el-tab-pane label="订单记录" name="first"/>
    <el-tab-pane label="带客(单)" name="second" v-if="listType == 1"/>
    <el-tab-pane label="打卡礼记录" name="third" v-if="listType == 1"/>
    <el-tab-pane label="连单礼记录" name="fourth" v-if="listType == 1"/>
    <el-tab-pane label="优惠券记录" name="fifth"/>
    <el-tab-pane label="签到礼记录" name="sixth"/>
    <el-tab-pane label="引客到店记录" name="seventh"/>
    <el-tab-pane label="创客分享记录" name="eighth"/>
  </el-tabs>
  
  <!-- 报名记录 -->
  <div class="main_container" v-show="activeName=='ninth'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item label="" style="display:flex;width:25%">
        <el-input v-model="bmjlPhone" placeholder="请输入用户电话" maxlength="11" style="width:90%;"/>
      </el-form-item>
      <el-form-item style="margin-right: 10px;"> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="daochu(7)">导出</el-button> </el-form-item>
    </el-form>
    <div class="table_container">
      <el-table :data="bmjlList" border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="用户电话" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="姓名" align="center">
          <template scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="年龄" align="center">
          <template scope="scope">{{scope.row.age}}</template>
        </el-table-column>
        <el-table-column label="是否已到场" align="center">
          <template scope="scope">{{scope.row.isBeen?'是':'否'}}</template>
        </el-table-column>
        <el-table-column label="参会方式" align="center">
          <template scope="scope">{{scope.row.attendMode}}</template>
        </el-table-column>
        <el-table-column label="到场记录" align="center">
          <template scope="scope">{{scope.row.beenTime}}</template>
        </el-table-column>
        <el-table-column label="报名时间" align="center">
          <template scope="scope">{{scope.row.signUpTime}}</template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template scope="scope">{{scope.row.remark}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingseven"
      :current-page="pageIndex7" :page-size="10" :total="totalRowsCount7" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 订单记录 -->
  <div class="main_container" v-show="activeName=='first'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item label="" style="display:flex;width:25%" v-if="listType == 1">
        <el-input v-model="ddjlName" placeholder="请输入店铺名称" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item label="" style="display:flex;width:25%">
        <el-input v-model="ddjlPhone" placeholder="请输入客户手机号" maxlength="11" style="width:90%;"/>
      </el-form-item>
      <el-form-item style="margin-right: 10px;"> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="daochu(0)">导出</el-button> </el-form-item>
    </el-form>
    <!-- 订单记录列表 -->
    <div class="table_container">
      <el-table :data="dpsmjlList" border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="店铺" align="center" v-if="listType == 1">
          <template scope="scope">{{scope.row.shopName}}</template>
        </el-table-column>
        <el-table-column label="订单号" align="center">
          <template scope="scope">{{scope.row.orderNo}}</template>
        </el-table-column>
        <el-table-column label="客户手机号" align="center">
          <template scope="scope">{{scope.row.userPhone}}</template>
        </el-table-column>
        <el-table-column label="交易时间" align="center">
          <template scope="scope">{{scope.row.orderTime}}</template>
        </el-table-column>
        <el-table-column label="款项类型" align="center">
          <template scope="scope">{{scope.row.paymentTypeName}}</template>
        </el-table-column>
        <el-table-column label="实付金额（元）" align="center">
          <template scope="scope">{{scope.row.orderPrice}}</template>
        </el-table-column>
        <el-table-column label="商家应得金额（元）" align="center">
          <template scope="scope">{{scope.row.shopPrice}}</template>
        </el-table-column>
        <el-table-column label="备注" align="center">
          <template scope="scope">{{scope.row.remark}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingOne"
      :current-page="pageIndex1" :page-size="10" :total="totalRowsCount1" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 带客(单) -->
  <div class="main_container" v-show="activeName=='second'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:25%">
        <el-input v-model="daikeName" placeholder="请输入带客店铺名称" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item style="display:flex;width:25%">
        <el-input v-model="partnerPhone" placeholder="请输入客户手机号" maxlength="11" style="width:90%;"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="daochu(1)">导出</el-button> </el-form-item>
    </el-form>
    <!-- 带客(单)列表 -->
    <div class="table_container">
      <el-table :data="ygfxhkList" border>
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column label="带客店铺" align="center">
          <template scope="scope">{{scope.row.helpShopName}}</template>
        </el-table-column>
        <el-table-column label="带客员工" align="center">
          <template scope="scope">{{scope.row.helpShopStaffPhone}}</template>
        </el-table-column>
        <el-table-column label="客户" align="center">
          <template scope="scope">{{scope.row.userPhone}}</template>
        </el-table-column>
        <el-table-column label="带客时间" align="center">
          <template scope="scope">{{scope.row.cTime}}</template>
        </el-table-column>
        <el-table-column label="目标店铺" align="center">
          <template scope="scope">{{scope.row.toShopName}}</template>
        </el-table-column>
        <el-table-column label="是否带单" align="center">
          <template scope="scope">{{scope.row.isOrder?'是':'否'}}</template>
        </el-table-column>
        <el-table-column label="单号" align="center">
          <template scope="scope">{{scope.row.orderNo}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingTwo"
      :current-page="pageIndex2" :page-size="10" :total="totalRowsCount2" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 打卡礼记录 -->
  <div class="main_container" v-show="activeName=='third'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:25%">
        <el-input v-model="dklPhone" placeholder="用户手机号" maxlength="11" style="width:90%;"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="daochu(2)">导出</el-button> </el-form-item>
    </el-form>
    <div class="table_container">
      <el-table :data="yglxsjList" border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="客户" prop="userPhone" align="center"/>
        <!-- <el-table-column label="拉新用户数" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="pullNewFun1(0,scope.row.id)">{{scope.row.newUserCount}}</span>
          </template>
        </el-table-column>
        <el-table-column label="平台会员" align="center">
          <template scope="scope">
            <span style="color:#409EFF;" @click="pullNewFun1(1,scope.row.id)">{{scope.row.newUserVIPCount}}</span>
          </template>
        </el-table-column> -->
        <el-table-column label="打卡进度" align="center">
          <template scope="scope">{{scope.row.successCount}}/{{scope.row.sumCount}}</template>
        </el-table-column>
        <el-table-column label="核销状态" prop="receiveState" align="center"/>
        <el-table-column label="核销时间" prop="receiveTime" align="center"/>
        <el-table-column label="核销人员" prop="staffPhone" align="center"/>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="handleSeeLlnr(scope.row)" class="handle"> <i class="el-icon-view"/> 打卡明细 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingThree"
      :current-page="pageIndex3" :page-size="10" :total="totalRowsCount3" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 连单礼记录 -->
  <div class="main_container" v-show="activeName=='fourth'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:25%">
        <el-input v-model="ldlPhone" placeholder="用户手机号" maxlength="11" style="width:90%;"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
      <el-form-item> <el-button type="danger" @click="daochu(3)">导出</el-button> </el-form-item>
    </el-form>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="dpllsjList" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="客户" align="center">
          <template scope="scope">{{scope.row.userPhone}}</template>
        </el-table-column>
        <el-table-column label="连单进度" align="center">
          <template scope="scope">{{scope.row.successCount}}/{{scope.row.sumCount}}</template>
        </el-table-column>
        <el-table-column label="核销状态" align="center">
          <template scope="scope">{{scope.row.receiveState}}</template>
        </el-table-column>
        <el-table-column label="核销时间" align="center">
          <template scope="scope">{{scope.row.receiveTime}}</template>
        </el-table-column>
        <el-table-column label="核销人员" align="center">
          <template scope="scope">{{scope.row.staffPhone}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="handleSeeLlmx(scope.row)" class="handle"> <i class="el-icon-view"/> 连单明细 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingFour"
      :current-page="pageIndex4" :page-size="10" :total="totalRowsCount4" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 优惠券记录 -->
  <div class="main_container" v-show="activeName=='fifth'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:25%" v-if="listType == 1">
        <el-input v-model="dpName" placeholder="请输入店铺名称" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item label="" style="display:flex;width:25%">
        <el-input v-model="yhqName" placeholder="请输入优惠券名称" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
    </el-form>
    <div class="table_container">
      <el-table :data="yhqList" stripe border>
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="券名称" align="center">
          <template scope="scope">{{scope.row.name}}</template>
        </el-table-column>
        <el-table-column label="所属店铺" align="center" v-if="listType == 1">
          <template scope="scope">{{scope.row.title}}</template>
        </el-table-column>
        <el-table-column label="优惠券面值" align="center">
          <template scope="scope">{{scope.row.faceValue}}</template>
        </el-table-column>
        <el-table-column label="使用门槛" align="center">
          <template scope="scope">{{scope.row.useThreshold}}</template>
        </el-table-column>
        <el-table-column label="售价" align="center">
          <template scope="scope">{{scope.row.price}}</template>
        </el-table-column>
        <el-table-column label="发放数量" align="center">
          <template scope="scope">{{scope.row.grantCount}}</template>
        </el-table-column>
        <el-table-column label="领取数量" align="center">
          <template scope="scope">{{scope.row.receiveCount}}</template>
        </el-table-column>
        <el-table-column label="核销数量" align="center">
          <template scope="scope">{{scope.row.useCount}}</template>
        </el-table-column>
        <el-table-column label="转换率" align="center">
          <template scope="scope">{{scope.row.convertRate}}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center">
          <template scope="scope">
            <span @click="seeInfo(scope.row)" class="handle"> <i class="el-icon-view"/> 查看 </span>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingFive"
      :current-page="pageIndex5" :page-size="10" :total="totalRowsCount5" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 签到礼记录 -->
  <div class="main_container" v-show="activeName=='sixth'">
    <!-- 搜索/查询 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:25%" v-if="listType == 1">
        <el-input v-model="qdlName" placeholder="请输入店铺名称" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item label="" style="display:flex;width:25%">
        <el-input v-model="qdlPhone" placeholder="请输入客户手机号" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">查询</el-button> </el-form-item>
    </el-form>
    <div class="table_container">
      <el-table :data="qdlList" stripe border>
        <el-table-column label="序号" align="center" width="60">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="领取时间" align="center">
          <template scope="scope">{{scope.row.receivetime}}</template>
        </el-table-column>
        <el-table-column label="客户手机号" align="center">
          <template scope="scope">{{scope.row.userphone}}</template>
        </el-table-column>
        <el-table-column label="核销店铺" align="center" v-if="listType == 1">
          <template scope="scope">{{scope.row.shopname}}</template>
        </el-table-column>
        <el-table-column label="员工手机号" align="center">
          <template scope="scope">{{scope.row.staffphone}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handlePagingSix"
      :current-page="pageIndex6" :page-size="10" :total="totalRowsCount6" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 引客到店记录 -->
  <div class="main_container" v-show="activeName=='seventh'">
    <!-- 顶部搜索框 -->
    <el-form class="findform">
      <el-form-item style="display:flex;width:25%">
        <el-input v-model="enterpriseName" placeholder="分享者昵称·分享者手机号" maxlength="20" style="width:90%;"/>
      </el-form-item>
      <el-form-item> <el-button type="danger" @click="onSubmit">搜索</el-button> </el-form-item>
    </el-form>
    <div style="margin: 0 0 15px 20px;">
      现金红包：每份 <b>{{ykddjl.rewardAmount}}</b> 元　
      共 <b>{{ykddjl.rewardAmountCount}}</b> 份　
      合计：<b>{{ykddjl.sum}}</b> 元　
      已领取 <b class="redClass">{{ykddjl.receivedCount}}</b> 份　
      剩余 <b class="redClass">{{ykddjl.surplus}}</b> 份　
      余额 <b class="redClass">{{ykddjl.balance}}</b> 元
    </div>
    <div class="table_container">
      <el-table :data="ykddlist" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="领取时间" align="center">
          <template scope="scope">{{scope.row.cTime}}</template>
        </el-table-column>
        <el-table-column label="分享者手机号" align="center">
          <template scope="scope">{{scope.row.coPhone}}</template>
        </el-table-column>
        <el-table-column label="客户手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
        <el-table-column label="核销店铺" align="center">
          <template scope="scope">{{scope.row.bbName}}</template>
        </el-table-column>
        <el-table-column label="员工手机号" align="center">
          <template scope="scope">{{scope.row.staffPhone}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="ykddchange"
      :current-page="pageykddindex" :page-size="10" :total="ykddcount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <!-- 创客分享记录 -->
  <div class="main_container" v-show="activeName=='eighth'">
    <div style="margin: 15px 0 15px 20px;">
      分享奖励：每份 <b>{{ckfxhz.univalence}}</b> 元　
      共 <b>{{ckfxhz.totalcount}}</b> 份　
      已领取 <b class="redClass">{{ckfxhz.consumecount}}</b> 份　
      剩余 <b class="redClass">{{ckfxhz.remaincount}}</b> 份　
      余额 <b class="redClass">{{ckfxhz.remainprice}}</b> 元　
      退款金额：<b>{{ckfxhz.refundprice}}</b> 元
    </div>
    <div class="table_container">
      <el-table :data="ckfxList" stripe border>
        <el-table-column label="序号" align="center" width="50">
          <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
        </el-table-column>
        <el-table-column label="领取时间" align="center">
          <template scope="scope">{{scope.row.createtime}}</template>
        </el-table-column>
        <el-table-column label="分享者手机号" align="center">
          <template scope="scope">{{scope.row.phone}}</template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="ckfxfenye"
      :current-page="pageCkfxindex" :page-size="10" :total="ckfxCount" style="margin:10px 0;float:right"/>
    </div>
  </div>
  
  <div style="width: 100%;text-align: center;margin-top: 20px;"><el-button @click="goback()">返回</el-button></div>
  
  <!-- 打卡明细 右侧抽屉组件 -->
  <el-drawer title="打卡明细" custom-class="registrationRecord" :visible.sync="visibleSeeLlnr" size="48%">
    <el-table :data="seeLlnrList" style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="店铺" property="name" align="center"/>
      <el-table-column label="打卡时间" property="cTime" align="center"/>
    </el-table>
    <!-- 打卡明细-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleLlnr"
      :current-page="pageIndexLlnr" :page-size="10" :total="totalRowsCountLlnr" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 连单明细 右侧抽屉组件 -->
  <el-drawer title="连单明细" custom-class="registrationRecord" :visible.sync="visibleSeeLlmx" size="48%">
    <el-table :data="seeLlmxList" style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column label="店铺" property="shopName" align="center"/>
      <el-table-column label="订单号" property="orderNo" align="center"/>
      <el-table-column label="交易时间" property="orderTime" align="center"/>
      <el-table-column label="款项类型" property="paymentTypeName" align="center"/>
      <el-table-column label="实付金额(元)" property="orderPrice" align="center"/>
      <el-table-column label="商家应得金额(元)" property="shopPrice" align="center"/>
    </el-table>
    <!-- 连单明细-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleLlmx"
      :current-page="pageIndexLlmx" :page-size="10" :total="totalRowsCountLlmx" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
  <!-- 查看详情 -->
  <el-drawer custom-class="registrationRecord" :visible.sync="seeDetails" size="40%">
    <template v-slot:title>
      <div class="drawer_title">{{couponDetails.Name}}</div>
    </template>
    <div class="drawerDiv">
      <p>优惠券信息</p>
      <ul>
        <li>售价：<span>{{couponDetails.Price}}</span></li>
        <li>优惠券面值：<span>{{couponDetails.FaceValue}}</span></li>
        <li>使用门槛：<span>{{couponDetails.UseExplain}}</span></li>
        <li>有效时间：<span>{{couponDetails.EffectiveDate}}</span></li>
        <li>每人领取：<span>{{couponDetails.ReceiveNumber}}</span></li>
      </ul>

      <p class="specialInstructions">优惠券特殊说明</p>
      <ul>
        <li v-html="couponDetails.SpecialInstructions"></li>
      </ul>
      
      <p>领取记录</p>
      <el-table :data="registrationRecordList">
        <el-table-column property="UserInfo" label="领取用户" align="center"/>
        <el-table-column property="GrantTime" label="领取时间" align="center"/>
        <el-table-column property="StatusName" label="状态" align="center"/>
      </el-table>
      <!-- 详情-分页 -->
      <el-pagination layout="prev, pager, next" @current-change="handleSubscription" :page-size="10"
        :current-page="subscriptionPageIndex" :total="subscriptionTotal" style="float: right; margin-top: 10px"/>
    </div>
  </el-drawer>
  
  <!-- 拉新用户数&平台会员 右侧抽屉组件 -->
  <el-drawer :title="titSix" custom-class="registrationRecord" :visible.sync="newUsersDrawer" direction="rtl" size="48%">
    <el-table :data="pullNewOrVipList" style="margin: 0px">
      <el-table-column label="序号" align="center" width="50">
        <template scope="scope"> <span>{{scope.$index + 1}}</span> </template>
      </el-table-column>
      <el-table-column property="name" label="用户昵称" align="center"/>
      <el-table-column property="phone" label="手机电话" align="center"/>
      <el-table-column property="newUserOrderCount" label="交易笔数" align="center"/>
      <el-table-column property="newUserOrderSum" label="交易金额(元)" align="center"/>
    </el-table>
    <!-- 拉新用户数&平台会员-分页 -->
    <el-col :span="24" style="margin-top:15px;float:right" class="order_toolbar_footer">
      <el-pagination layout="prev, pager, next" @current-change="handleTabSix"
      :current-page="pageIndexSix" :page-size="10" :total="totalRowsCountSix" style="float: right; margin-top: 10px"/>
    </el-col>
  </el-drawer>
  
</section>
</template>
<script>
import { getActivityDataCoupons, getSeeCoupoon, getGrantCoupoon, activitysignuprecored,
  getRechargeInfo, getRechargeRecord, poststatistics } from "../../api/activityFormList";
import { getActivityOrder, getActivityOrderRecordToExcel, getShopHelpCustomersToShop, getShopHelpCustomersToShopToExcel,
getToStoreRecord, getToStoreRecordToExcel, getToStoreRecordDetails, signupGetlist, getlistExport,
getContinuityOrderRecord, getContinuityOrderRecordToExcel, getActivityContinuityOrderDetails } from "../../api/shopWindow";
export default {
  name: 'activityDataList',
  data() {
    return {
      listId: '', // 列表选中行id
      activeName: 'ninth', // 报名记录
      
      bmjlPhone: '',
      bmjlList: [], // 报名记录
      pageIndex7: 1,
      totalRowsCount7: 0,
      
      ddjlName: '', // 名称
      ddjlPhone: '', // 手机号
      dpsmjlList: [], // 订单记录
      pageIndex1: 1,
      totalRowsCount1: 0,

      daikeName: '', // 名称
      partnerPhone: '', // 手机号
      ygfxhkList: [], // 带客(单)
      pageIndex2: 1,
      totalRowsCount2: 0,
      
      dklPhone: '', // 打卡礼手机号
      yglxsjList: [], // 打卡礼记录
      pageIndex3: 1,
      totalRowsCount3: 0,

      ldlPhone: '', // 连单礼手机号
      dpllsjList: [], // 连单礼记录
      pageIndex4: 1,
      totalRowsCount4: 0,

      dpName: '', // 店铺名称
      yhqName: '', // 优惠券名称
      yhqList: [], // 优惠券记录
      pageIndex5: 1,
      totalRowsCount5: 0,

      qdlName: '', // 店铺名称
      qdlPhone: '', // 客户手机号
      qdlList: [], // 签到礼记录
      pageIndex6: 1,
      totalRowsCount6: 0,

      dkmxId: '', // 打卡明细id
      visibleSeeLlnr: false, // 打卡明细-抽屉
      seeLlnrList: [], // 打卡明细-列表
      pageIndexLlnr: 1,
      totalRowsCountLlnr: 0,

      ldmxId: '', // 连单明细id
      visibleSeeLlmx: false, // 连单明细-抽屉
      seeLlmxList: [], // 连单明细-列表
      pageIndexLlmx: 1,
      totalRowsCountLlmx: 0,
      
      seeDetails: false, // 查看详情抽屉
      couponDetails: {}, // 优惠券信息
      registrationRecordList: [], // 认购记录列表
      subscriptionPageIndex: 1, // 认购记录分页页码
      subscriptionTotal: 0, // 认购记录总条数

      titSix: '',   // 拉新用户数或者平台会员弹框标题
      newUsersDrawer: false, // 拉新用户数抽屉控制显隐
      pullNewOrVipList: [], // 拉新用户数、平台会员列表
      pageIndexSix: 1,   // 拉新用户数列表分页
      totalRowsCountSix: 0, // 拉新用户数列表总数

      enterpriseName: '', // 分享者昵称·分享者手机号
      ykddjl: {}, // 引客到店记录 汇总信息
      ykddlist: [], // 引客到店记录
      pageykddindex: 1,
      ykddcount: 0, 

      ckfxhz: {},
      ckfxList: [],
      pageCkfxindex: 1, // 页码
      ckfxCount: 0,
      
      listType: '', // 区分:1联盟活动 or 2店铺活动
    }
  },
  methods: {
    // 返回
    goback() { this.$router.go(-1); },
    // 点击tab切换
    handleClick(tab, event) {
      this.ddjlName = '';
      this.ddjlPhone = '';
      this.activeName = tab.name;
      if(tab.name=='ninth'){
        this.totalRowsCount7 = 0;
        this.getBmjl(); // 列表7
      }
      if(tab.name=='first'){
        this.totalRowsCount1 = 0;
        this.getDdjl(); // 列表1
      }
      if(tab.name=='second'){
        this.totalRowsCount2 = 0;
        this.getDkd(); // 列表2
      }
      if(tab.name=='third'){
        this.totalRowsCount3 = 0;
        this.getDkljl(); // 列表3
      }
      if(tab.name=='fourth'){
        this.totalRowsCount4 = 0;
        this.getLdljl(); // 列表4
      }
      if(tab.name=='fifth'){
        this.totalRowsCount5 = 0;
        this.getYhqjl(); // 列表5
      }
      if(tab.name=='sixth'){
        this.totalRowsCount6 = 0;
        this.getQdljl(); // 列表6
      }
      if(tab.name=='seventh'){
        this.getTgjlHz(); // 引客到店记录-汇总
        this.pageykddindex = 1;
        this.getTgjlList();
      }
      if(tab.name=='eighth'){
        this.pageCkfxindex = 1;
        this.ckfxjlList();
      }
    },
    // 查询
    onSubmit() {
      if(this.activeName=='ninth'){
        this.pageIndex7 = 1;
        this.getBmjl();
      }
      if(this.activeName=='first'){
        this.pageIndex1 = 1;
        this.getDdjl();
      }
      if(this.activeName=='second'){
        this.pageIndex2 = 1;
        this.getDkd();
      }
      if(this.activeName=='third'){
        this.pageIndex3 = 1;
        this.getDkljl();
      }
      if(this.activeName=='fourth'){
        this.pageIndex4 = 1;
        this.getLdljl();
      }
      if(this.activeName=='fifth'){
        this.pageIndex5 = 1;
        this.getYhqjl();
      }
      if(this.activeName=='sixth'){
        this.pageIndex6 = 1;
        this.getQdljl();
      }
      if(this.activeName=='seventh'){
        this.pageykddindex = val;
        this.getTgjlList();
      }
    },
    // 导出
    daochu(val) {
      if(val == 0) {
        let addParams = {
          activityId: this.listId, // 活动id
          shopName: this.ddjlName, // 名称
          phone: this.ddjlPhone, // 手机号
        };
        getActivityOrderRecordToExcel(addParams).then(data => {})
      }
      if(val == 1) {
        let addParams = {
          activityId: this.listId, // 活动id
          shopName: this.daikeName, // 名称
          phone: this.partnerPhone, // 手机号
        };
        getShopHelpCustomersToShopToExcel(addParams).then(data => {})
      }
      if(val == 2) {
        let addParams = {
          activityId: this.listId, // 活动id
          phone: this.dklPhone, // 手机号
        };
        getToStoreRecordToExcel(addParams).then(data => {})
      }
      if(val == 3) {
        let addParams = {
          activityId: this.listId, // 活动id
          phone: this.ldlPhone, // 手机号
        };
        getContinuityOrderRecordToExcel(addParams).then(data => {})
      }
      if(val == 7) {
        getlistExport('',this.listId).then(data => {})
      }
    },
    // 报名记录
    getBmjl() {
      let addParams = {
        ActivityId: this.listId, // 活动id
        phone: this.bmjlPhone, // 手机号
        PageIndex: this.pageIndex7,// 页码
        PageSize: 10 // 每页行数
      };
      signupGetlist(addParams).then(data => {
        if (data.resultCode == 1) {
          this.bmjlList = data.resultObj.list;
          this.totalRowsCount7 = data.resultObj.totalcount;
        } else {
          this.bmjlList = [];
          this.totalRowsCount7 = 0;
        }
      })
    },
    // 分页-报名记录
    handlePagingseven(val) {
      this.pageIndex7 = val;
      this.getBmjl();
    },
    // 订单记录
    getDdjl() {
      let addParams = {
        activityId: this.listId, // 活动id
        shopName: this.ddjlName, // 名称
        phone: this.ddjlPhone, // 手机号
        pageIndex: this.pageIndex1,// 页码
        pageSize: 10 // 每页行数
      };
      getActivityOrder(addParams).then(data => {
        if (data.resultCode == 1) {
          this.dpsmjlList = data.resultObj.resultObj;
          this.totalRowsCount1 = data.resultObj.rowsCount;
        } else {
          this.dpsmjlList = [];
          this.totalRowsCount1 = 0;
        }
      })
    },
    // 分页1
    handlePagingOne(val) {
      this.pageIndex1 = val;
      this.getDdjl();
    },
    
    // 带客(单)
    getDkd() {
      let addParams = {
        activityId: this.listId, // 活动id
        shopName: this.daikeName, // 名称
        phone: this.partnerPhone, // 手机号
        pageIndex: this.pageIndex2,// 页码
        pageSize: 10 // 每页行数
      };
      getShopHelpCustomersToShop(addParams).then(data => {
        if (data.resultCode == 1) {
          this.ygfxhkList = data.resultObj.resultObj;
          this.totalRowsCount2 = data.resultObj.rowsCount;
        } else {
          this.ygfxhkList = [];
          this.totalRowsCount2 = 0;
        }
      })
    },
    // 分页2
    handlePagingTwo(val) {
      this.pageIndex2 = val;
      this.getDkd();
    },
    // 打卡礼记录
    getDkljl(){
      let addParams = {
        activityId: this.listId, // 活动id
        phone: this.dklPhone, // 手机号
        pageIndex: this.pageIndex3,
        pageSize: 10,
      };
      getToStoreRecord(addParams).then(data => {
        if (data.resultCode == 1) {
          this.yglxsjList = data.resultObj.resultObj;
          this.totalRowsCount3 = data.resultObj.rowsCount;
        } else {
          this.yglxsjList = []
        }
      })
      this.pageIndexSix = 1;
    },
    // 分页3
    handlePagingThree(val) {
      this.pageIndex3 = val;
      this.getDkljl();
    },
    // 打卡明细
    handleSeeLlnr(row) {
      this.dkmxId = row.userId // id
      this.getLlnr();
      this.visibleSeeLlnr = true;
    },
    // 打卡明细-列表
    getLlnr(){
      let addParams = {
        activityId: this.listId, // 活动id
        userId: this.dkmxId, // id
        pageIndex: this.pageIndexLlnr, // 页码
        pageSize: 10, // 条数
      };
      getToStoreRecordDetails(addParams).then(data => {
        if (data.resultCode == 1) {
          this.seeLlnrList = data.resultObj.resultObj;
          this.totalRowsCountLlnr = data.resultObj.rowsCount;
        } else {
          this.seeLlnrList = []
        }
      })
    },
    // 打卡明细-分页
    handleLlnr(val) {
      this.pageIndexLlnr = val;
      this.getLlnr();
    },
    // 连单礼记录
    getLdljl(){
      let addParams = {
        activityId: this.listId, // 活动id
        phone: this.ldlPhone, // 手机号
        pageIndex: this.pageIndex4, // 页码
        pageSize: 10, // 条数
      };
      getContinuityOrderRecord(addParams).then(data => {
        if (data.resultCode == 1) {
          this.dpllsjList = data.resultObj.resultObj;
          this.totalRowsCount4 = data.resultObj.rowsCount;
        } else {
          this.dpllsjList = []
        }
      })
    },
    // 分页4
    handlePagingFour(val) {
      this.pageIndex4 = val;
      this.getLdljl();
    },
    // 连单明细
    handleSeeLlmx(row) {
      this.ldmxId = row.userId // id
      this.getLlmx();
      this.visibleSeeLlmx = true;
    },
    // 连单明细-列表
    getLlmx(){
      let addParams = {
        activityId: this.listId, // 活动id
        userId: this.ldmxId, // id
        pageIndex: this.pageIndexLlmx, // 页码
        pageSize: 10, // 条数
      };
      getActivityContinuityOrderDetails(addParams).then(data => {
        if (data.resultCode == 1) {
          this.seeLlmxList = data.resultObj.resultObj;
          this.totalRowsCountLlmx = data.resultObj.rowsCount;
        } else {
          this.seeLlmxList = []
        }
      })
    },
    // 连单明细-分页
    handleLlmx(val) {
      this.pageIndexLlmx = val;
      this.getLlmx();
    },
    // 优惠券记录
    getYhqjl(){
      let addParams = {
        activityId: this.listId, // 活动id
        name: this.dpName, // 店铺名称
        key: this.yhqName, // 优惠券名称
        pageIndex: this.pageIndex5, // 页码
        pageSize: 10, // 条数
      };
      getActivityDataCoupons(addParams).then(data => {
        if (data.resultCode == 1) {
          this.yhqList = data.resultObj.resultObj;
          this.totalRowsCount5 = data.resultObj.rowsCount;
        } else {
          this.yhqList = []
        }
      })
    },
    // 分页5
    handlePagingFive(val) {
      this.pageIndex5 = val;
      this.getYhqjl();
    },
    // 签到礼记录
    getQdljl(){
      let addParams = {
        activityId: this.listId, // 活动id
        shopName: this.qdlName, // 店铺名称
        phone: this.qdlPhone, // 客户手机号
        pageIndex: this.pageIndex6, // 页码
        pageSize: 10, // 条数
      };
      activitysignuprecored(addParams).then(data => {
        if (data.resultCode == 1) {
          this.qdlList = data.resultObj.resultObj;
          this.totalRowsCount6 = data.resultObj.rowsCount;
        } else {
          this.qdlList = []
        }
      })
    },
    // 分页6
    handlePagingSix(val) {
      this.pageIndex6 = val;
      this.getQdljl();
    },
    // 拉新用户数+平台会员
    pullNewFun1(row, id){
      if(row==0){
        this.titSix = '拉新用户数';
      } else {
        this.titSix = '平台会员';
      }
      let addParams = {
        thisBbid: this.bbid,   //进入模块时下拉框选择的店铺id
        bbid: this.bbid,     //点击列表查看的店铺id
        staffId: id,    //员工id
        isVip: row,   // 0=拉新用户数、1=平台会员
        dateType: 0,
        beginDate: this.beginDate,
        endDate: this.endDate,
        pageIndex: this.pageIndexSix,
        pageSize: 10,
        maId: this.maIdSix, // 联盟id int类型   （列表左上方下拉列表选中的联盟id）
      };
      statisticsStaffNewUserList(addParams).then(data => {
        if (data.resultCode == 1) {
          console.log(data.resultObj,'员工维度的拉新用户数/平台会员')
          this.pullNewOrVipList = data.resultObj.resultObj;
          this.totalRowsCountSix = data.resultObj.rowsCount;
        } else {
          this.pullNewOrVipList = []
        }
      })
      this.newUsersDrawer = true;
    },
    // 拉新用户数 分页
    handleTabSix(val) {
      this.pageIndexSix = val;
      this.pullNewFun1();
    },
    // 查看
    seeInfo(row) {
      this.couponId = row.id;
      this.seeDetails = true;
      this.subscriptionPageIndex = 1;
      // 查询详情信息
      var obj = { couponId: this.couponId };
      getSeeCoupoon(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.couponDetails = data.ResultObj;
        }
      });
      this.pushSubscriptionRecords(); // 认购记录列表
    },
    // 认购记录接口
    pushSubscriptionRecords() {
      var obj = {
        CouponId: this.couponId,
        PageIndex: this.subscriptionPageIndex, // 页码
        PageSize: 10, // 条数
      };
      getGrantCoupoon(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.registrationRecordList = data.ResultObj;
          this.subscriptionTotal = data.RowsCount;
        } else {
          this.registrationRecordList = [];
        }
      });
    },
    // 查询认购记录分页
    handleSubscription(val) {
      this.subscriptionPageIndex = val;
      this.pushSubscriptionRecords();
    },
    
    // 引客到店记录-汇总
    getTgjlHz() {
      let addObjTwo = {
        activityId: this.listId // 活动id
      }
      getRechargeInfo(addObjTwo).then(data => {
        if(data.resultCode == 1) {
          this.ykddjl = data.resultObj;
        }
      })
    },
    // 查询 引客到店记录 列表
    getTgjlList() {
      let addObjOne = {
        activityId: this.listId, // 活动id
        key: this.enterpriseName, // 关键字
        pageIndex: this.pageykddindex, // 页码
        pageSize: 10, // 条数
      }
      getRechargeRecord(addObjOne).then(data => {
        if(data.resultCode == 1) {
          this.ykddlist = data.resultObj.resultObj;
          this.ykddcount = data.resultObj.rowsCount;
        } else {
          this.ykddlist = [];
          this.ykddcount = 0;
        }
      })
    },
    // 引客到店记录-分页
    ykddchange() {
      this.pageykddindex = 1;
      this.getTgjlList();
    },
    // 创客分享记录
    ckfxjlList() {
      let obj = {
        activityid: this.listId, // 活动id
        pageindex: this.pageCkfxindex, // 页码
        pagesize: 10, // 条数
      }
      poststatistics(obj).then(data => {
        if(data.resultCode == 1) {
          this.ckfxhz = data.resultObj;
          this.ckfxList = data.resultObj.consumedata.list;
          this.ckfxCount = data.resultObj.consumedata.totalcount;
        } else {
          this.ckfxList = [];
        }
      })
    },
    // 创客分享记录-分页
    ckfxfenye(val) {
      this.pageCkfxindex = val;
      this.ckfxjlList();
    },
    
  },
  created() {
    this.listId = this.$route.query.Id;
    this.listType = this.$route.query.type; // 区分:1联盟活动 or 2店铺活动
    this.getBmjl(); // 查询报名记录
  }
}
</script>
<style scoped>
.fhdw {
  position: absolute;
  right: 20px;
}
/* 抽屉-详情 */
.drawerDiv {
  width: 100%;
  position: relative;
  margin-top: -15px;
}
.drawerDiv>p {
  width: 80%;
  font-size: 15px;
  font-weight: bold;
}
.drawerDiv>ul {
  width: 93%;
  border-bottom: 1px solid #eee;
  padding-left: 30px;
  padding-bottom: 10px;
}
.drawerDiv>ul>li {
  width: 100%;
  color: #888;
  font-size: 15px;
  margin-bottom: 5px;
}
.drawerDiv>ul>li>span {
  font-size: 16px;
  color: #333;
  margin-left: 5px;
  line-height: 26px;
}
</style>


// WEBPACK FOOTER //
// activityDataList.vue?ba1d6d7c